import { useRef } from "react";
import { motion, useInView } from "framer-motion";

const H = (h) => (h / 24) * 100;

const types = [
  { name: "EARLY", from: 6.5, to: 11, share: "About 1 in 4" },
  { name: "MIDDLE", from: 9, to: 13.5, share: "Roughly half" },
  { name: "LATE", from: 12, to: 17.5, share: "About 1 in 4" },
];

export const ChronotypeBars = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });

  return (
    <div ref={ref} data-testid="science-chronotype-bars">
      <div className="flex justify-between font-mono-brand text-[9px] sm:text-[10px] tracking-[0.2em] text-[#6E7178] mb-3">
        <span>06</span>
        <span>12</span>
        <span>18</span>
        <span>24</span>
      </div>
      <div className="space-y-5">
        {types.map((t, i) => (
          <div key={t.name} data-testid={`science-chronotype-${t.name.toLowerCase()}`}>
            <div className="flex items-baseline justify-between mb-2">
              <span className="font-mono-brand text-[10px] sm:text-[11px] tracking-[0.22em] text-[#F2F0EB]">{t.name}</span>
              <span className="font-mono-brand text-[9px] sm:text-[10px] tracking-[0.16em] uppercase text-[#6E7178]">
                Peak {Math.floor(t.from)}:00 to {Math.floor(t.to)}:00 &middot; {t.share}
              </span>
            </div>
            <div className="relative h-7 bg-[#F2F0EB]/[0.05]">
              <motion.div
                className="absolute top-0 bottom-0 bg-[#FF4D0A]"
                style={{ left: `${H(t.from)}%` }}
                initial={{ width: 0 }}
                animate={inView ? { width: `${H(t.to) - H(t.from)}%` } : { width: 0 }}
                transition={{ duration: 1, delay: 0.15 + i * 0.18, ease: [0.22, 1, 0.36, 1] }}
              />
            </div>
          </div>
        ))}
      </div>
      <p className="font-mono-brand text-[10px] tracking-[0.2em] uppercase text-[#6E7178] mt-6">
        Peak windows shift by hours across the population.
      </p>
    </div>
  );
};
